import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LanguageService } from '../shared/service/language.service';

@Injectable({
  providedIn: 'root'
})
export class RouterLanguageGaurdGuard  {

  private readonly router = inject(Router) 
  private readonly languageService = inject(LanguageService)
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const languageId = this.languageService.getLanguage();
      const originalUrl = state.url;      
      if(originalUrl.startsWith('/events') || originalUrl.startsWith('/home')  || originalUrl.startsWith('/profile')) {
        const modifiedUrl = `/${languageId}${originalUrl}`;
        this.router.navigate([modifiedUrl]);
      } 
      return true;
  } 
}
